<template>
  <c-search-form :input-search-items="searchItems" :rows-per-page-items="[100]" :input-create-items="createItems"
                 :form-name="formName"
                 model="searchForm" :fields="fields" accept-copy
                 key-property="formId"
                 search-url="/form/search"
                 create-url="/form/save"
                 delete-url="/form/delete"
                 delete-multi-url="/form/deleteList"
                 form-type="intable"
  >
    <u-form-create :default-data="this.$parent.selectedItem" slot="createForm"
                   :input-items="createItems" create-url="/form/save"
                   form-name="lang.form.add_edit" ref="createForm"/>
  </c-search-form>
</template>

<script>
  import CSearchForm from "../../../components/form/ManageForm";
  import UFormCreate from "./FormCreate";

  export default {
    name: 'form-management',
    components: {UFormCreate, CSearchForm},
    data: () => {
      return {
        formName: "lang.form.title",
        searchItems: [
          {
            type: "text",
            name: "formCode",
            label: "lang.form.code",
            placeHolder: "",
            focus: true
          },
          {
            type: "text",
            name: "formName",
            label: "lang.form.name",
            placeHolder: ""
          }
        ],
        createItems: [
          {
            type: "text",
            name: "formCode",
            label: "lang.form.code",
            validate: "required",
            maxlength: '50',
            placeHolder: "",
            errorText: "Lỗi"
          },
          {
            type: "text",
            name: "formName",
            label: "lang.form.name",
            validate: "required",
            maxlength: '250',
            placeHolder: ""
          }
        ],
        fields: [
          {value: "checkbox", sortable: false, headerStyle: "text-align:center",width:"5%"},
          {value: "index", text: "lang.common.index", width: "5%", sortable: false, headerStyle: "text-align:center"},
          {
            value: 'formCode',
            text: 'lang.form.code',
            search: true,
            width: "10%",
            sortable: true,
            headerStyle: "text-align:left"
          },
          {
            value: 'formName',
            text: 'lang.form.name',
            search: true,
            width: "20%",
            sortable: true,
            headerStyle: "text-align:left"
          },
          {
            value: 'createdAt',
            text: 'lang.common.create_update_at',
            width: "20%",
            sortable: true,
            dateFormat: 'dd/MM/yyyy hh:mm',
            headerStyle: "text-align:left"
          },
          {
            value: 'creatorName',
            text: 'lang.common.create_by',
            width: "10%",
            sortable: true,
            headerStyle: "text-align:left"
          },
          {
            value: 'action',
            text: "lang.common.actions",
            width: "20%",
            sortable: false,
            compound: true,
            headerAlign: "center",
            headerStyle: "text-align:center",
          }
        ]
      }
    }
  }
</script>
